import React from 'react';
import classNames from 'classnames';
import { AbstractRadio } from 'Permafrost/index';
import { StyledFlipper } from './Flipper.styles';
/**
 * Allows a user to “flip” between modes of some sort.
 */
export function Flipper(props) {
    const { className, currentMode, groupLabel, id, onModeChange, modes, small } = props;
    return (React.createElement(StyledFlipper, { "aria-label": groupLabel, "data-cy": props['data-cy'], value: currentMode, id: id, onChange: onModeChange, orientation: "horizontal", className: classNames('switch-pair', className, { small }) }, modes.map((mode) => (React.createElement(AbstractRadio, { key: mode, value: mode }, mode)))));
}
//# sourceMappingURL=Flipper.js.map